module.exports = __webpack_public_path__ + "static/media/communicationrequest.js.8d60b8ab.map";